// Input que será usado para quando precisar ter controle sobre o valor do input

import { InputAdornment, TextField } from "@mui/material"

import { SxOneTextField, SxOneInputProps } from './OneInput2Style'

const OneInput2 = ({
    name = "",
    value = '',
    type = 'text',
    StartIcon = false,
    EndIcon = false,
    IconCallback = false,
    maxLength = "",
    textarea = false,
    transform = false,
    disabled = false,
    readOnly = false,
    onBlur = () => {},
    callback = () => {},
    ...rest
}) => {
    return (
        <TextField
            variant="outlined"
            sx={{ ...SxOneTextField, backgroundColor: (disabled || readOnly ? "#c9c7c7" : "#fff") }}
            name={name}
            {...rest}
            value={value}
            type={type}
            multiline={textarea}
            onBlur={onBlur}
            onChange={callback}
            inputProps={{
                maxLength,
                disabled,
                readOnly,
                // required,
                sx: { padding: '0 5px' },
                ...rest
            }}
            InputProps={{
                sx: textarea ? { ...SxOneInputProps, height: '100%', padding: '0 4px', margin: 0 } : SxOneInputProps,
                startAdornment: (
                    StartIcon && <InputAdornment position="start">
                        <StartIcon onClick={() => IconCallback()} />
                    </InputAdornment>
                ),
                endAdornment: (
                    EndIcon && <InputAdornment position="start">
                        <EndIcon style={{ cursor: 'pointer' }} onClick={() => IconCallback()}/>
                    </InputAdornment>
                )
            }}
        />
    )
}

export default OneInput2
